import React from "react";
import { setCollapseLeaderBoard } from '../../../actions/dashboard';
import Header from "./Header";
import Body from "./Body";
import { Col } from 'react-bootstrap';
import { useDispatch } from "react-redux";

const LeaderBoard = (props) => {
  const { collapseLeaderBoard } = props;
  const dispatch = useDispatch();
  const toggleLeaderBoard = () => {
    dispatch(setCollapseLeaderBoard());
  };

  return (
    <Col className="h-100 p-0">
      <div
        className="collapse-btn-toggle"
        onClick={() => toggleLeaderBoard()}
      >
        <i
          className={
            collapseLeaderBoard
              ? "fa fa-chevron-right"
              : "fa fa-chevron-left"
          }
        ></i>
      </div>
      {/* {!collapseLeaderBoard && ( */}
        <div className={`h-100 mobile-h-100 ${collapseLeaderBoard ? "d-none" : ""}`}>
          <Header />
          <Body />
        </div>
      {/* )} */}
    </Col>
  );
};

export default LeaderBoard;
